/* product-gallery.js — product page gallery, hover zoom, lightbox */
'use strict';

(function () {
  var galleryDataEl = document.getElementById('ccProductGalleryData');
  var mainImg = document.getElementById('ccGalleryMain');
  var mainWrap = document.getElementById('ccGalleryMainWrap');
  var zoomTrigger = document.getElementById('ccGalleryZoomTrigger');
  var lightbox = document.getElementById('ccGalleryLightbox');
  var lightboxImg = document.getElementById('ccGalleryLightboxImg');
  var lightboxStage = document.getElementById('ccGalleryLightboxStage');
  var lightboxCounter = document.getElementById('ccGalleryLightboxCounter');
  var prevBtn = document.getElementById('ccGalleryLightboxPrev');
  var nextBtn = document.getElementById('ccGalleryLightboxNext');
  var thumbs = document.querySelectorAll('.cc-gallery-thumb');

  if (!galleryDataEl || !mainImg) return;

  var images = [];
  try {
    images = JSON.parse(galleryDataEl.textContent);
  } catch (e) {
    return;
  }

  var activeIndex = 0;
  var lightboxOpen = false;
  var lightboxScale = 1;
  var pinchStartDist = 0;
  var pinchStartScale = 1;
  var canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var preloadCache = Object.create(null);
  var hoverRaf = null;

  function preload(url) {
    if (!url || preloadCache[url]) return preloadCache[url];
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
    preloadCache[url] = img;
    return img;
  }

  function galleryFullSrc(item) {
    return item.full || item.zoom || item.src;
  }

  function warmGallery() {
    images.forEach(function (item, i) {
      if (i < 4) preload(item.src);
      else window.setTimeout(function () { preload(item.src); preload(item.zoom); }, i * 40);
    });
  }

  function applySrc(el, url) {
    if (!el || !url) return;
    var cached = preload(url);
    if (cached.complete && cached.naturalWidth) {
      el.src = url;
      el.classList.remove('is-loading');
    } else {
      el.classList.add('is-loading');
      cached.onload = function () {
        el.src = url;
        el.classList.remove('is-loading');
      };
    }
  }

  function clampIndex(i) {
    if (!images.length) return 0;
    return (i + images.length) % images.length;
  }

  function resetMainTransform() {
    if (!mainImg) return;
    mainImg.style.transform = 'scale(1)';
    mainImg.style.transformOrigin = 'center center';
  }

  function setMainImage(index) {
    activeIndex = clampIndex(index);
    var item = images[activeIndex];
    if (!item) return;

    resetMainTransform();
    applySrc(mainImg, item.src);
    mainImg.dataset.zoomSrc = item.zoom;
    mainImg.alt = item.alt || '';

    preload(item.zoom);
    if (images[activeIndex + 1]) preload(images[activeIndex + 1].src);
    if (images[activeIndex - 1]) preload(images[activeIndex - 1].src);

    thumbs.forEach(function (thumb) {
      var isActive = parseInt(thumb.dataset.index, 10) === activeIndex;
      thumb.classList.toggle('active', isActive);
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (lightboxOpen && lightboxImg) {
      resetLightboxZoom();
      applySrc(lightboxImg, galleryFullSrc(item));
      lightboxImg.alt = item.alt || '';
      updateCounter();
    }
  }

  function updateCounter() {
    if (lightboxCounter && images.length > 1) {
      lightboxCounter.textContent = (activeIndex + 1) + ' / ' + images.length;
    }
  }

  function resetLightboxZoom() {
    lightboxScale = 1;
    if (lightboxImg) {
      lightboxImg.style.transform = 'scale(1)';
      lightboxImg.style.transition = '';
    }
    if (lightboxStage) lightboxStage.classList.remove('is-zoomed');
  }

  function setLightboxScale(scale) {
    lightboxScale = scale;
    if (!lightboxImg) return;
    lightboxImg.style.transition = scale === 1 ? 'transform 0.15s ease' : 'none';
    lightboxImg.style.transform = 'scale(' + scale + ')';
    if (lightboxStage) lightboxStage.classList.toggle('is-zoomed', scale > 1.05);
  }

  function ensureLightboxFullRes() {
    var item = images[activeIndex];
    if (!item || !lightboxImg) return;
    var fullSrc = galleryFullSrc(item);
    if (lightboxImg.currentSrc !== fullSrc && lightboxImg.src !== fullSrc) {
      applySrc(lightboxImg, fullSrc);
    }
  }

  function openLightbox(index) {
    if (!lightbox || !lightboxImg) return;
    setMainImage(index);
    lightboxOpen = true;
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    applySrc(lightboxImg, galleryFullSrc(images[activeIndex]));
    lightboxImg.alt = images[activeIndex].alt || '';
    preload(galleryFullSrc(images[activeIndex]));
    resetLightboxZoom();
    updateCounter();
    lightbox.querySelector('.cc-gallery-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightboxOpen = false;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetLightboxZoom();
    window.setTimeout(function () {
      if (!lightboxOpen) lightbox.hidden = true;
    }, 280);
    if (zoomTrigger) zoomTrigger.focus();
  }

  function stepLightbox(delta) {
    setMainImage(activeIndex + delta);
  }

  warmGallery();

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('mouseenter', function () {
      var idx = parseInt(thumb.dataset.index, 10);
      if (images[idx]) preload(images[idx].src);
    });
    thumb.addEventListener('click', function () {
      setMainImage(parseInt(thumb.dataset.index, 10));
    });
  });

  if (zoomTrigger) {
    zoomTrigger.addEventListener('click', function () {
      openLightbox(activeIndex);
    });
  }

  if (lightbox) {
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { stepLightbox(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stepLightbox(1); });

    document.addEventListener('keydown', function (e) {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') stepLightbox(-1);
      if (e.key === 'ArrowRight') stepLightbox(1);
    });
  }

  if (canHoverZoom && mainWrap && mainImg) {
    mainWrap.classList.add('has-hover-zoom');

    mainWrap.addEventListener('mouseenter', function () {
      var item = images[activeIndex];
      if (item && item.zoom) applySrc(mainImg, item.zoom);
    });

    mainWrap.addEventListener('mousemove', function (e) {
      if (hoverRaf) return;
      hoverRaf = window.requestAnimationFrame(function () {
        hoverRaf = null;
        var rect = mainWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
        mainImg.style.transform = 'scale(2)';
      });
    });

    mainWrap.addEventListener('mouseleave', function () {
      var item = images[activeIndex];
      if (item && item.src) applySrc(mainImg, item.src);
      resetMainTransform();
    });
  }

  if (lightboxStage && lightboxImg) {
    var lastTap = 0;
    var touchStartX = 0;

    lightboxStage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        ensureLightboxFullRes();
        pinchStartDist = getTouchDistance(e.touches);
        pinchStartScale = lightboxScale;
      } else if (e.touches.length === 1 && lightboxScale <= 1.05) {
        touchStartX = e.touches[0].clientX;
      }
    }, { passive: true });

    lightboxStage.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 2) return;
      e.preventDefault();
      ensureLightboxFullRes();
      var dist = getTouchDistance(e.touches);
      setLightboxScale(Math.min(3, Math.max(1, pinchStartScale * (dist / pinchStartDist))));
    }, { passive: false });

    lightboxStage.addEventListener('touchend', function (e) {
      if (e.touches.length > 0) return;
      if (lightboxScale < 1.05) resetLightboxZoom();
      else if (lightboxScale <= 1.05 && e.changedTouches.length) {
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) > 50) stepLightbox(deltaX > 0 ? -1 : 1);
      }
    });

    lightboxStage.addEventListener('click', function (e) {
      if (!lightboxOpen) return;
      var now = Date.now();
      if (now - lastTap < 300) {
        if (lightboxScale > 1.05) resetLightboxZoom();
        else {
          ensureLightboxFullRes();
          setLightboxScale(2);
        }
        lastTap = 0;
        e.preventDefault();
        return;
      }
      lastTap = now;
    });
  }

  function findImageIndex(detail) {
    if (!detail) return -1;

    if (detail.imageId != null) {
      var byId = images.findIndex(function (img) {
        return img.id === detail.imageId;
      });
      if (byId >= 0) return byId;
    }

    if (detail.src) {
      var target = imageKey(detail.src);
      return images.findIndex(function (img) {
        return imageKey(img.src) === target || imageKey(img.zoom) === target || imageKey(img.full) === target;
      });
    }

    return -1;
  }

  function imageKey(url) {
    if (!url) return '';
    return String(url).split('?')[0].split('/').pop();
  }

  function showVariantImage(detail) {
    var idx = findImageIndex(detail);
    if (idx >= 0) setMainImage(idx);
  }

  document.addEventListener('homestar:gallery-show-image', function (e) {
    showVariantImage(e.detail);
  });

  window.HomestarProductGallery = {
    showVariantImage: showVariantImage,
    setMainImage: setMainImage
  };

  function getTouchDistance(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }
})();
